// extracted by mini-css-extract-plugin
export default {"container":"Container_container__r5+0N","hidden":"Container_hidden__FLJqP","heading":"Container_heading__hDXZZ","titleContainer":"Container_titleContainer__vjj9S"};